import React from "react";
import { Check, Loader2 } from "lucide-react";

/**
 * Inline step-progress indicator for long-running API operations.
 * Drop it directly below the trigger button; it appears/disappears based on isRunning.
 *
 * Props: pass spread from useProgressSteps — { steps, currentStep, pct, isRunning }
 */
export function ProgressSteps({ steps, currentStep, pct }) {
  const activeLabel = steps[currentStep]?.label ?? "";

  return (
    <div className="border border-border bg-secondary/30 p-4 mt-3 animate-in fade-in duration-200">
      {/* Bar + step counter */}
      <div className="flex items-center justify-between mb-1.5">
        <span className="font-mono text-[10px] text-foreground tracking-[0.1em]">
          {activeLabel}…
        </span>
        <span className="font-mono text-[10px] text-muted-foreground">
          {currentStep + 1} / {steps.length}
        </span>
      </div>
      <div className="h-0.5 bg-border overflow-hidden mb-4 rounded-full">
        <div
          className="h-full bg-[#0025D8] transition-all duration-700 ease-out"
          style={{ width: `${pct}%` }}
        />
      </div>

      {/* Step list */}
      <div className="space-y-1.5">
        {steps.map((s, i) => {
          const done = i < currentStep;
          const active = i === currentStep;
          return (
            <div key={s.label} className={`flex items-center gap-2 transition-opacity ${i > currentStep ? "opacity-30" : "opacity-100"}`}>
              {done ? (
                <Check className="w-3 h-3 text-[#10B981] flex-shrink-0" />
              ) : active ? (
                <Loader2 className="w-3 h-3 text-[#0025D8] animate-spin flex-shrink-0" />
              ) : (
                <div className="w-3 h-3 rounded-full border border-border flex-shrink-0" />
              )}
              <span className={`font-mono text-[10px] ${active ? "text-foreground" : "text-muted-foreground"}`}>
                {s.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
